import React from 'react';
import Viewer from '../../Viewer';
import { extConfig } from '../../../Editor/presets/Journal/config';
import { ExternalReactRenderers } from '../../../Editor/types';
import cn from 'classnames';
import { Measureable } from '../../types';

import s from './Journal.scss';

export interface Props extends Measureable {
  contentJson: any;
  className?: string;
  externalRenderers: ExternalReactRenderers;
}

const JournalViewer = React.forwardRef<HTMLDivElement, Props>(
  ({ contentJson, className, externalRenderers, cookieType, defaultSize }, ref) => {
    return (
      <Viewer
        presetId="journal"
        contentJson={contentJson}
        className={cn(s['root'], className)}
        extensionConfig={extConfig}
        externalRenderers={externalRenderers}
        cookieType={cookieType}
        defaultSize={defaultSize}
        ref={ref}
      />
    );
  }
);
JournalViewer.displayName = 'JournalViewer';

export default JournalViewer;
